import React from 'react';
import { useScreen } from '../../lib/useScreen';
import TiltCard from '../../lib/TiltCard';
import { glassCard } from '../shared/constants';

export default function Card({ children, style: s, borderTopColor, className, ...rest }) {
  const { isMobile } = useScreen();
  return (
    <TiltCard
      disabled={isMobile}
      className={`glass-card${className ? ' ' + className : ''}`}
      style={{
        ...glassCard,
        padding: '1.5rem',
        borderTop: borderTopColor ? `3px solid ${borderTopColor}` : undefined,
        ...s,
      }}
      glowColor={borderTopColor ? borderTopColor + '60' : 'rgba(93,193,185,0.3)'}
      {...rest}>
      {children}
    </TiltCard>
  );
}
